module.exports = __webpack_public_path__ + "img/faseh-branco.d85dd180.svg";